
import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useGeolocation } from '@/hooks/useGeolocation';

const POPUP_LAST_SHOWN_KEY = 'location_popup_last_shown';
const DONT_ASK_AGAIN_KEY = 'location_popup_dont_ask';

export const useLocationPermissionPopup = () => {
  const { user } = useAuth();
  const { hasLocation, getCurrentLocation } = useGeolocation();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!user || hasLocation) {
      return;
    }

    // Check if user has opted out
    const dontAskAgain = localStorage.getItem(DONT_ASK_AGAIN_KEY) === 'true';
    if (dontAskAgain) {
      return;
    }

    // Check if popup was already shown today
    const lastShown = localStorage.getItem(POPUP_LAST_SHOWN_KEY);
    const today = new Date().toDateString();
    
    if (lastShown === today) {
      return;
    }

    // Show popup after a short delay to ensure UI is ready
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [user, hasLocation]);

  const handleEnableLocation = async () => {
    try {
      await getCurrentLocation(true);
      setShowPopup(false);
    } catch (error) {
      console.error('Failed to get location:', error);
      setShowPopup(false);
    }
  };

  const handleNotNow = () => {
    const today = new Date().toDateString();
    localStorage.setItem(POPUP_LAST_SHOWN_KEY, today);
    setShowPopup(false);
  };

  const handleDontAskAgain = () => {
    localStorage.setItem(DONT_ASK_AGAIN_KEY, 'true');
    const today = new Date().toDateString();
    localStorage.setItem(POPUP_LAST_SHOWN_KEY, today);
    setShowPopup(false);
  };

  return {
    showPopup,
    handleEnableLocation,
    handleNotNow,
    handleDontAskAgain
  };
};
